export default "__VITE_ASSET__DwTOySNS__"